import {
  ConcreteExperienceMessage,
  IExperienceMessageDenormalized,
  MessageStatus
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../i18next';
import { DateWithTooltip } from './DateWithTooltip';

export const MessageSendDate = ({
  msg,
  concreteMessages
}: {
  msg: IExperienceMessageDenormalized;
  concreteMessages: ConcreteExperienceMessage[];
}) => {
  const { t } = useUnsafeTranslation();
  // TODO - MESSAGES
  const mostRecentConcreteMessage =
    concreteMessages[concreteMessages.length - 1];

  // For errors show when we tried to send last
  // otherwise just take the most recent date and show it

  return msg.status === MessageStatus.UPCOMING ||
    msg.status === MessageStatus.SKIPPED ? (
    <>
      <DateWithTooltip
        textBefore={
          msg.status === MessageStatus.SKIPPED
            ? `${t('Would have sent on')}`
            : `${t('Will be sent on')} `
        }
        date={msg.sendAt}
      />
    </>
  ) : msg.status === MessageStatus.DONE ||
    msg.status === MessageStatus.ERROR ? (
    <>
      <DateWithTooltip
        textBefore={`${t('Sent on')}`}
        date={mostRecentConcreteMessage?.at || msg.sendAt}
      />
    </>
  ) : null;
};
